import { config } from "config";
import { eventChannel } from "redux-saga";
import { decryptData } from "utils";

let eventSource; // Module-level variable to hold the reference

// Common function to create an EventSource channel
export function createEventSourceChannel(API_URL) {
  if (eventSource && eventSource.readyState === 1) {
    console.log("EventSource connection already open.");
    return; // Prevent new connection
  }
  const token = localStorage.getItem("token");
  const username = decryptData(localStorage.getItem("mirrorId"));
  const url = `${config.VIRT_URL}${API_URL}/?username=${username}&token=${token}`;
  eventSource = new EventSource(url);

  return eventChannel(emitter => {
    eventSource.onmessage = event => {
      if (event.data) {
        const validJsonString = event.data.replace(/'/g, '"');
        const parsedData = JSON.parse(validJsonString);
        emitter(parsedData);
      }
    };

    eventSource.onerror = error => {
      console.log(error);
      emitter(new Error("SSE Error")); // Handle errors and propagate them
      eventSource.close();
    };

    // Close the channel when the eventSource is closed
    return () => {
      console.log("closing the sse connection");
      eventSource.close();
    };
  });
}

export function closeEventSourceConnection() {
  if (eventSource) {
    eventSource.close();
    eventSource = null; // Clean up reference
  }
}
